import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";

import { BY_DEPARTURE_TIME, BY_DURATION, BY_MIN_PRICE } from "../../../constants";
import { setFilterParams } from "../../../store/resultFiltersSlice";

import { SortTab, Wrapper } from "./style";

/**
 * FE-14: сортировка была выпадающим списком внутри колонки фильтров и знала
 * только про цену. По макету это табы над списком с тремя режимами.
 */
const ResultsSortingComponent = () => {
  const { t } = i18next;
  const {
    filterParams: {
      sorting: { value },
    },
  } = useSelector(state => state.resultFilters);
  const dispatch = useDispatch();

  const options = [
    { value: BY_MIN_PRICE, label: t("sort_cheaper") },
    { value: BY_DURATION, label: t("sort_faster") },
    { value: BY_DEPARTURE_TIME, label: t("sort_earlier") },
  ];

  const handleSelect = newValue => {
    dispatch(
      setFilterParams({
        type: "sorting",
        values: {
          // цена по возрастанию — состояние по умолчанию, его не считаем «активным фильтром»
          isActive: newValue !== BY_MIN_PRICE,
          value: newValue,
        },
      })
    );
  };

  return (
    <Wrapper role="tablist" aria-label={t("sorting")}>
      {options.map(option => (
        <SortTab
          key={option.value}
          type="button"
          role="tab"
          aria-selected={value === option.value}
          $active={value === option.value}
          onClick={() => handleSelect(option.value)}
        >
          {option.label}
        </SortTab>
      ))}
    </Wrapper>
  );
};

export default ResultsSortingComponent;
